import type { CrashFilters } from '../../../api/crashes'
import { Segmented } from '../../Segmented'

/** The window, build, kind and view the crash lists are filtered by. */
export function CrashFiltersBar({ value, onChange }: { value: CrashFilters; onChange(next: CrashFilters): void }) {
	return (
		<div className="row" style={{ flexWrap: 'wrap' }}>
			<Segmented
				label="View"
				value={value.resolved ? 'resolved' : 'open'}
				options={[
					{ value: 'open', label: 'Open' },
					{ value: 'resolved', label: 'Resolved' },
				]}
				onChange={(v) => onChange({ ...value, resolved: v === 'resolved' })}
			/>
			<select
				aria-label="Window"
				value={value.days}
				onChange={(e) => onChange({ ...value, days: Number(e.target.value) })}
			>
				{[1, 7, 30, 90, 365].map((d) => (
					<option key={d} value={d}>
						{d === 1 ? 'Last day' : `Last ${d} days`}
					</option>
				))}
			</select>
			<select
				aria-label="Kind"
				value={value.kind}
				onChange={(e) => onChange({ ...value, kind: e.target.value as CrashFilters['kind'] })}
			>
				<option value="">Crashes and hangs</option>
				<option value="crash">Crashes</option>
				<option value="hang">Hangs</option>
			</select>
			<input
				aria-label="Build"
				placeholder="Build"
				value={value.build}
				maxLength={40}
				onChange={(e) => onChange({ ...value, build: e.target.value.trim() })}
				style={{ width: '7rem' }}
			/>
			<label className="row small">
				<input
					type="checkbox"
					checked={value.shippingOnly}
					onChange={(e) => onChange({ ...value, shippingOnly: e.target.checked })}
				/>
				Shipping builds only
			</label>
		</div>
	)
}
